export default function ImgSrcChangePlugin(Vue, router, options) {
  Vue.directive("gesture-back", {
    inserted: function inserted(el, binding, vnode) {
      var touchStartX = 0;
      var touchEndX = 0;
      var fn = binding.value;
      el.addEventListener("touchstart", function (e) {
        touchStartX = e.touches[0].clientX;
      });
      el.addEventListener("touchmove", function (e) {
        touchEndX = e.touches[0].clientX;
      });
      el.addEventListener("touchend", function (e) {
        var moveX = touchEndX - touchStartX;

        if (touchStartX <= 50 && moveX >= 50) {
          fn && fn();
        }
      });
    }
  });
}